<template>
  <div class="approval-flow-started-banner d-flex align-start ga-2 pa-2 w-100">
    <p class="approval-flow-started-banner-text text-body-3 text-textDarkest font-weight-medium flex-grow-1 mb-0">
      An approval workflow has been started for
      <span class="font-weight-bold">{{ jobTitle }}</span>.
      Stage {{ currentStage }} reviewers for this job have been notified.
    </p>
    <div
      class="approval-flow-started-banner-close"
      role="button"
      tabindex="0"
      aria-label="Dismiss"
      @click="$emit('close')"
      @keydown.enter="$emit('close')"
    >
      <DpplSvg file-name="icon-close-small" />
    </div>
  </div>
</template>

<script setup>
import DpplSvg from '@/components/datapeople/DpplSvg.vue';

defineProps({
  jobTitle: {
    type: String,
    default: '',
  },
  currentStage: {
    type: Number,
    default: 1,
  },
});

defineEmits(['close']);
</script>

<style scoped lang="less">
.approval-flow-started-banner {
  background: @yellow-100;
  border: 1px solid @yellow-500;
  border-radius: 8px;
}

.approval-flow-started-banner-text {
  line-height: 1.5;
  padding: 0 10px;
}

.approval-flow-started-banner-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  cursor: pointer;

  :deep(svg path) {
    stroke: @icon-dark;
  }
}
</style>
